import { forwardRef, KeyboardEvent } from "react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Icon } from "@/components/ui/icon";

interface OttoInputProps {
  value: string;
  onChange: (value: string) => void;
  onSend: () => void;
  disabled?: boolean;
}

export const OttoInput = forwardRef<HTMLInputElement, OttoInputProps>(
  ({ value, onChange, onSend, disabled = false }, ref) => {
    const handleKeyDown = (e: KeyboardEvent<HTMLInputElement>) => {
      if (e.key === "Enter" && !e.shiftKey) {
        e.preventDefault();
        onSend();
      }
    };

    return (
      <div className="p-4 border-t border-border">
        <div className="flex gap-2">
          <Input
            ref={ref}
            value={value}
            onChange={(e) => onChange(e.target.value)}
            onKeyDown={handleKeyDown}
            placeholder="Type a message..."
            disabled={disabled}
            className="flex-1"
          />
          <Button
            onClick={onSend}
            disabled={!value.trim() || disabled}
            size="icon"
          >
            <Icon name="send" size={16} />
          </Button>
        </div>
      </div>
    );
  }
);

OttoInput.displayName = "OttoInput";
